import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import AlertSummary from '../components/AlertSummary/AlertSummary.js';
import { fetchAlertSummaryDataByType } from '../actions/alertSummaryByType.js';
import { fetchAlertConfig } from '../actions/fetchAlertConfig.js';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { transformAlertMetrics } from '../../../utils/transformChartsAndTableData.js';
import get from 'lodash/get';
import { setSorting, resetSorting, toggleSorting } from '../../FeedBackList/actions/sortingActions.js';
import AlertSummaryLoader from '../components/AlertSummary/Loader.js';
import { parseFilters } from '../../Filters/utils/fetchData.js';
import GenericNoData from '../../../components/Common/NoData/GenricNoData.js';

const Alerts = props => {
  const {
    actions,
    alerts_summary_data,
    applied_filter_values,
    applied_filters,
    alerts_config,
    filtersLoading,
    isFetchingAlertsData,
    sortReducer,
    isFetchingAlertsConfig
  } = props;

  const [sortingInProgress, setSortingInProgress] = useState(false);
  const timeperiodLabel = get(applied_filters, 'timePeriod[0].fullLabel', ' ');
  useEffect(() => {
    actions.fetchAlertConfig();
  }, [actions]);

  useEffect(() => {
    if (sortingInProgress && !isFetchingAlertsData) {
      setSortingInProgress(false);
    }
  }, [isFetchingAlertsData, sortingInProgress]);

  if (!sortingInProgress && (isFetchingAlertsConfig || filtersLoading || isFetchingAlertsData)) {
    return (
      <View style={{ margin: 30 }}>
        <AlertSummaryLoader />
      </View>
    );
  }

  const alerts_data = transformAlertMetrics(alerts_summary_data, timeperiodLabel);

  if (!sortingInProgress && !alerts_data?.alerts?.length) {
    return <GenericNoData />;
  }

  const handleOnSortClick = key => {
    setSortingInProgress(true);
    actions.toggleSorting(key);

    const { filters } = parseFilters(applied_filter_values);

    if (!filters || Object.keys(filters).length === 0) return;

    actions.fetchAlertSummaryDataByType(filters);
  };

  return (
    <View style={{ margin: 30 }}>
      <AlertSummary
        alerts_data={alerts_data}
        applied_filter_values={applied_filter_values}
        applied_filters={applied_filters}
        columns={alerts_config?.contents?.alerts_headers}
        sortConfig={sortReducer}
        handleOnSortClick={handleOnSortClick}
        sortingInProgress={sortingInProgress}
        alerts_config={alerts_config}
      />
    </View>
  );
};

const mapStateToProps = state => ({
  alerts_summary_data: state.alertSummaryReducer.alerts_summary_data,
  alerts_config: state.alertSummaryReducer.alerts_config,
  isFetchingAlertsData: state.alertSummaryReducer.isFetchingAlertsData,
  isFetchingAlertsConfig: state.alertSummaryReducer.isFetchingAlertsConfig,
  applied_filter_values: get(state, 'filterReducer.applied_filter_values'),
  applied_filters: get(state, 'filterReducer.applied_filters'),
  filtersLoading: get(state, 'filterReducer.filtersLoading'),
  sortReducer: state.sortReducer
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    { fetchAlertConfig, fetchAlertSummaryDataByType, setSorting, resetSorting, toggleSorting },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(Alerts);
